//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import StripeIndividualFields from "./stripe/stripeIndividualFields.vue";
import StripeFields from "./stripe/stripeFields.vue";
export default {
  components: {
    StripeIndividualFields: StripeIndividualFields,
    StripeFields: StripeFields
  },
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      stripe: null,
      card: null,
      paymentMethodId: null,
      brand: null,
      country: null,
      last4: null
    };
  },
  methods: {
    $ready: function $ready() {
      this.paymentMethodId = null;
      this.brand = null;
      this.country = null;
      this.last4 = null;
    },
    _displayError: function _displayError(message) {
      var displayError = this.$refs.error;
      displayError.textContent = message;
    },
    _retrieveToken: function _retrieveToken(stripe, card) {
      // this.$dispatchEvent("forms/setBusy", { value: true });
      // const vm = this;
      // stripe.createToken(card).then(function(result) {
      //   if (result.error) {
      //     vm._displayError(result.error.message);
      //   } else {
      //     vm._displayError("");
      //     const token = result.token;
      //     vm.$refs.token.setAttribute("value", token.id);
      //   }
      //   vm.$dispatchEvent("forms/setBusy", { value: false });
      // });
      this._createPaymentMethod(stripe, card);
    },
    _createPaymentMethod: function _createPaymentMethod(stripe, card) {
      this.$dispatchEvent("forms/setBusy", {
        value: true
      });
      var vm = this;
      stripe.createPaymentMethod("card", card).then(function (result) {
        if (result.error) {
          vm._displayError(result.error.message);
        } else {
          vm._displayError("");

          vm.paymentMethodId = result.paymentMethod.id;
          vm.brand = result.paymentMethod.card.brand;
          vm.country = result.paymentMethod.card.country;
          vm.last4 = result.paymentMethod.card.last4;
        }

        vm.$dispatchEvent("forms/setBusy", {
          value: false
        });
      });
    }
  }
};